import React, { useMemo } from "react";
import { ResearchId } from "../../../adapters/insights-agent/state/AppState.ts";
import {
  useMessagesState,
  useResearchState,
} from "../../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useInsightsAgentService } from "../../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { InsightsAgentChatBox } from "../domain-components/ChatBox/InsightsAgentChatBox.tsx";

export const ConnectedChatBox: React.FC<{
  researchId: ResearchId;
  filterDialogComponent?: React.ReactNode;
  regenerateButton?: React.ReactNode;
  filterChips?: React.ReactNode;
  knowledgeSourceDropdown?: React.ReactNode;
}> = (props) => {
  const appService = useInsightsAgentService();
  const research = useResearchState(props.researchId);
  const messages = useMessagesState(props.researchId);
  const isProcessing = useMemo(
    () =>
      research?.status !== "completed" ||
      research.regenerating_summary ||
      messages.some((message) => message.status === "optimistic"),
    [messages, research?.regenerating_summary, research?.status],
  );
  return (
    <InsightsAgentChatBox
      onSubmit={(value) => {
        appService
          .sendMessage({ researchId: props.researchId, message: value })
          .then();
      }}
      knowledgeSource={research?.knowledge_source}
      processing={isProcessing}
      filterDialogComponent={props.filterDialogComponent}
      filterChips={props.filterChips}
      regenerateButton={props.regenerateButton}
      knowledgeSourceDropdown={props.knowledgeSourceDropdown}
    />
  );
};
